module.exports = ".line-height {\r\n    line-height: 2;\r\n}\r\n\r\n.submit-btn {\r\n    margin: 20px 0 0 0 ;\r\n}"